import { render, staticRenderFns } from "./BarCode.vue?vue&type=template&id=2f835f5e&"
import script from "./BarCode.vue?vue&type=script&lang=js&"
export * from "./BarCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports